export enum CoverageErrorType {
  KO_COVERAGE,
  KO_TECHNICAL,
}


